// src/packages/chubb/travel/chubb_travel_international/ChubbTravelCard.jsx
import React from "react";
import "./chubb_travel.css";

export default function ChubbTravelCard({ onSelect }) {
  return (
    <div className="pkg-card chubb-travel">
      <div className="pkg-body">
        <h3>Chubb Travel – International</h3>
        <p>คุ้มครองฉุกเฉินต่างประเทศ + ยกเลิก/เลื่อนทริป + กระเป๋า + เที่ยวบินล่าช้า</p>

        <ul className="pkg-list">
          <li>ค่ารักษาพยาบาลต่างประเทศ & การอพยพฉุกเฉิน</li>
          <li>ยกเลิก/เลื่อนการเดินทางจากเหตุฉุกเฉินที่คุ้มครอง</li>
          <li>กระเป๋าเดินทางหาย/เสียหาย & ของใช้จำเป็นฉุกเฉิน</li>
          <li>เที่ยวบินล่าช้า/พลาดต่อเครื่องตามเงื่อนไข</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect} aria-label="ดูรายละเอียด Chubb Travel">
          ดูรายละเอียด
        </button>
      </div>
    </div>
  );
}
